import { IconButton, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import PostAddIcon from '@material-ui/icons/PostAdd';
import { openModalExtrasPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"

const BExtras = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()
    const handleClick = () => {
        dispatch(openModalExtrasPaqueteTerrestre({
          paquete
        }))
    }

    return (
        <Tooltip title="Extras">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <PostAddIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BExtras